import React, { useState } from 'react';

import { MtxButton } from '@meilleurtaux/mtp-uikit-react';

import { MAJOR_ADULT_LEGAL_CAPACITY } from '@/enums/userLegalCapacity';
import { useNavigationToKYC } from '@/hooks/useNavigationToKYC';
import useScreenSize from '@/hooks/useScreenSize';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

const WarningKyc: React.FC<AlertKycProps> = ({ legalCapacity, onClickShowModal }) => {
  const { windowWidth } = useScreenSize();
  const [showMore, setShowMore] = useState(false);
  const { navigateToKYC } = useNavigationToKYC();
  const description = `Elles sont déclaratives et utilisées uniquement dans le cadre de la gestion de votre dossier, conformément à la réglementation en vigueur.`;

  const checkProfil = (cLegalCapacity: string): void => {
    if (cLegalCapacity in MAJOR_ADULT_LEGAL_CAPACITY) {
      void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
        event_id: 'clic',
        event_categorie: 'clic',
        event_nom: 'mettre a jour mes informations',
        event_metier: 'espace client placement',
        event_detail_1: 'cta',
        event_detail_2: 'bandeau',
      });
      navigateToKYC();
    } else {
      void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
        event_id: 'action',
        event_categorie: 'affichage popin données personnelles mineur',
        event_nom: 'affichage popin données personnelles mineur',
        event_metier: 'espace client placement',
        event_detail_1: 'cta',
        event_detail_2: 'mon_portefeuille',
      });
      onClickShowModal();
    }
  };

  const renderDescription = () => {
    if (windowWidth >= 600) {
      return description;
    }

    return (
      <>
        {showMore && (
          <div className={`${styles.description} ${showMore ? styles.showMoreClass : styles.showLessClass}`}>
            {description}
          </div>
        )}
        <br></br>
        <button onClick={() => setShowMore((prev) => !prev)} className={styles.buttonShowMore} aria-expanded={showMore}>
          {showMore ? 'Afficher moins' : 'Afficher plus'}
        </button>
      </>
    );
  };

  return (
    <div className={styles.alertKYC}>
      <div className={styles.alertIcon}>
        <i className="totem-icon totem-icon-warning-solide" />
      </div>
      <div className={styles.alertContent}>
        <div className={styles.alertText}>
          <span>
            Vos données personnelles doivent être actualisées, nous vous prions de bien vouloir vérifier leur validité.
          </span>
          <p>
            Celles-ci conditionnent directement la qualité de notre conseil.&nbsp;
            {renderDescription()}
          </p>
        </div>
        <div className={styles.alertButton}>
          <MtxButton variant="tertiary" size="small" fullWidth={true} onClick={() => checkProfil(legalCapacity ?? '')}>
            {legalCapacity && legalCapacity in MAJOR_ADULT_LEGAL_CAPACITY ? 'Mettre à jour' : 'Voir plus'}
          </MtxButton>
        </div>
      </div>
    </div>
  );
};

export interface AlertKycProps {
  legalCapacity: string | null | undefined;
  onClickShowModal: () => void;
}

export default WarningKyc;
